'use client';

import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleGroup, CollapsibleToggler } from '@faceless-ui/collapsibles';
import { RichText } from '../../components/RichText';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import type { PagesQuery } from '../../graphql/generated/schema';
import styles from './styles.module.scss';
import { BlockContainer } from '../../components/layouts';

export const Faq: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'Faq'>> = ({
  faqs,
  blockSettings,
}) => (
  <BlockContainer
    blockSettings={blockSettings}
  >
    <CollapsibleGroup>
      {faqs?.map((faq, index) => (
        <div
          className={styles.contentContainer}
          key={faq.id}
        >
          <Collapsible
            transTime={250}
            openOnInit={index === 0}
          >
            <CollapsibleToggler
              key={faq.id}
              className={styles.toggle}
            >
              <span className={styles.question}>{faq.question}</span>
            </CollapsibleToggler>
            <CollapsibleContent>

              <RichText
                className={styles.answer}
                data={faq.answer}
              />
            </CollapsibleContent>
          </Collapsible>
        </div>
      ))}
    </CollapsibleGroup>
  </BlockContainer>
);
